import { render, staticRenderFns } from "./emails.vue?vue&type=template&id=a0999f88&scoped=true"
import script from "./emails.vue?vue&type=script&lang=js"
export * from "./emails.vue?vue&type=script&lang=js"
import style0 from "./emails.vue?vue&type=style&index=0&id=a0999f88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0999f88",
  null
  
)

export default component.exports